var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.7 15c-2.5.8-5.4.3-7.4-1.7-2.5-2.5-2.7-6.5-.7-9.3-4.1.4-7.3 3.8-7.3 8 0 4.4 3.6 8 8 8 3.3 0 6.2-2.1 7.4-5",
    clipRule: "evenodd"
  })));
};
export { SvgMoon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWQ0MmZiNTFlNjgyOTZjMDkxYzhmN2M2ZDIwODNmZTkuc3ZnIjs=";